import { Box } from '@mui/material';
import { theme } from 'config/theme';
import LightbulbFillIcon from 'remixicon-react/LightbulbFillIcon';
import { styled } from '@mui/material/styles';
import { INDUSTRY_INSIGHTS } from '../constants';

export const BuildWiseInsightsBadge = styled(Box)(({ theme }) => ({
  color: theme.palette.custom.brown,
  backgroundColor: theme.palette.custom.earlyDawn,
  padding: '4px 8px',
  fontSize: 14,
  display: 'flex',
  alignItems: 'center',
  borderRadius: 8,
}));

export const renderInsightTypeOptionLabel = (type: string) => {
  switch (type) {
    case INDUSTRY_INSIGHTS: {
      return (
        <BuildWiseInsightsBadge>
          <LightbulbFillIcon size={20} color={theme.palette.custom.pirateGold} />
          &nbsp;{INDUSTRY_INSIGHTS}
        </BuildWiseInsightsBadge>
      );
    }

    default:
      return type;
  }
};
